import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dialog", "unpublishForm", "deactivateForm",
    "unpublishDialog", "unpublishDirectForm",
    "publishDialog", "publishDirectForm"
  ]

  // Opens the deactivate modal (with Unpublish / Deactivate / Cancel)
  open(event) {
    event.preventDefault()
    const btn = event.currentTarget
    this.unpublishFormTarget.action = btn.dataset.unpublishPath
    this.deactivateFormTarget.action = btn.dataset.deactivatePath
    this._showDialog(this.dialogTarget)
  }

  // Opens the unpublish confirmation modal
  openUnpublish(event) {
    event.preventDefault()
    const btn = event.currentTarget
    this.unpublishDirectFormTarget.action = btn.dataset.unpublishPath
    this._showDialog(this.unpublishDialogTarget)
  }

  // Opens the publish confirmation modal
  openPublish(event) {
    event.preventDefault()
    const btn = event.currentTarget
    this.publishDirectFormTarget.action = btn.dataset.publishPath
    this._showDialog(this.publishDialogTarget)
  }

  close(event) {
    if (event) event.preventDefault()
    ;[this.dialogTarget, this.unpublishDialogTarget, this.publishDialogTarget].forEach(d => {
      if (d && d.open) d.close()
    })
  }

  _showDialog(dialog) {
    dialog.showModal()
    dialog.addEventListener("click", (e) => {
      if (e.target === dialog) dialog.close()
    }, { once: true })
  }
}
